/**
 * Next.js `sizes` hint for RecipieCard.
 * Picks decode width only — does not change CSS box, crop, or object-cover
 * (`h-48` / `sm:h-52`). One conservative hint so 1-col phone never undersizes;
 * slightly oversized on 2-col mobile is OK. Per-layout variants were reverted
 * (designer: one standardized size, compress/WebP before layout-specific files).
 */
export const RECIPE_CARD_SIZES =
  '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw'
